<template>
    <v-menu
        ref="menu"
        v-model="pickerOpen"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="localDate"
                :label="label"
                prepend-inner-icon="$calendar"
                readonly
                v-bind="{...attrs, ...$attrs}"
                v-on="on"
                required
                clearable
                @click:clear="clearDate"
                :disabled="disabled"
            ></v-text-field>
        </template>
        <v-date-picker
            v-model="dateValue"
            :picker-date.sync="displayDate"
            :min="minDate"
            no-title
            scrollable
            locale="pt-br"
            :range="range"
            @click:date="!range ? $refs.menu.save(dateValue) : null"
        >
            <v-spacer></v-spacer>
            <v-btn
                text
                color="primary"
                @click="pickerOpen = false"
            >
                Cancelar
            </v-btn>
            <v-btn
                v-if="range"
                text
                color="primary"
                @click="$refs.menu.save(dateValue)"
            >
                OK
            </v-btn>
        </v-date-picker>
    </v-menu>
</template>

<script>
import FormBaseModel from '@cp-models/FormBaseModel'

export default {
    inheritAttrs: false,

    props: {
        label: {
            require: true,
        },
        currentDate: {
            require: true,
        },
        disabled: {
            default: false,
        },
        min: {
            default: null,
        },
        range: {
            type: Boolean,
            default: false,
        },
    },

    data: _ => ({
        baseModel: new FormBaseModel,
        pickerOpen: false,
        displayDate: null
    }),

    model: {
        prop: 'currentDate',
        event: 'dateChange'
    },

    watch: {
        pickerOpen(isOpen) {
            if (isOpen) {
                if (!this.dateValue && this.minDate) {
                    this.displayDate = this.minDate;
                }
            }
        }
    },

    methods: {
        clearDate() {
            this.dateValue = this.range ? [] : null
        }
    },

    computed: {
        localDate: {
            get: function () {
                if (!this.dateValue) {
                    return ''
                }

                // Se for range, dateValue é um array com duas datas
                if (this.range && Array.isArray(this.dateValue)) {
                    const dates = this.dateValue
                        .map(date => {
                            const formattedDate = date && date.length > 10
                                ? date.substring(0, 10)
                                : date
                            return formattedDate ? this.baseModel.formatDate(formattedDate, true) : ''
                        })
                        .filter(date => date !== '')

                    return dates.length > 0 ? dates.join(' - ') : ''
                }

                // Se não for range, é uma data única
                if (typeof this.dateValue === 'string' && this.dateValue.length >= 10) {
                    const date = this.dateValue.substring(0, 10)
                    return this.baseModel.formatDate(date, true)
                }

                return ''
            },
            set: function (_newDate) {
            }
        },
        dateValue: {
            get: function () {
                return this.currentDate
            },
            set: function (newDate) {
                this.$emit('dateChange', newDate)
            }
        },
        minDate() {
            if (!this.min) {
                return null
            }

            return this.min.length > 10
                ? this.min.substring(0, 10)
                : this.min
        },
    }
}
</script>

<style>

</style>